import { ref, Ref, computed } from "vue";
import { YuukyuuKanriService } from "@/service/YuukyuuKanriService";
import { GetDaichouInfoRes, YuukyuuShinseiData, YuukyuuKanriOption } from "@/types/YuukyuuKanri";
import { useRoute } from "vue-router";
import { BaseOption } from "@/types/Option";


/*
 * 初期処理
 */
export function useInit() {
    const route = useRoute()
    const code = parseInt(route.params.code as string, 10)
    const syutokuList: Ref<YuukyuuShinseiData[]> = ref([])
    const daichouInfo: Ref<GetDaichouInfoRes> = ref({
        user_id: null,
        staff_code: null,
        staff_name: null,
        start_date: null,
        end_date: null,
        this_year_fuyo_date: null,
        konnen_fuyo_days: 0,
        yuukyuu_total: 0,
        tokubetsu_kyuuka: 0,
        zennen_kurikoshi_days: 0,
    })

    const loading = ref(0); // APIで読み込みをする本数
    const isError = ref(false);

    // 個人別有給管理台帳の付与日選択オプション取得
    const getFuyobiOptions = async (userId: number, options: Ref<YuukyuuKanriOption[]>) => {
        loading.value++;

        const srv = new YuukyuuKanriService();
        srv.getFuyobiOptions(userId).then(res => {
            loading.value--;

            if (res) {
                options.value = res;
            } else {
                // エラー
                isError.value = true;
                options.value = [];
            }
            return;
        });
    }

    // 読み込み中か判断する
    const isInitLoading = computed(() => {
        return !(loading.value === 0 || isError.value);
    });

    return {
        syutokuList,
        daichouInfo,
        code,
        isInitLoading,
        getFuyobiOptions,
    }
}
